export default __webpack_public_path__ + "static/media/RR310_LateralDer.edc2bf58.webp";